/**
 * Weirwood
 * Copyright 2019 Baidu Inc. All rights reserved.
 *
 * @file 一些帮助函数
 * @author zengxiaohui(zengxiaohui@baidu.com)
 */
import { htmlTreeAsString } from '../utils/misc';
var debounceDuration = 1000;
var keypressTimeout;
var lastCapturedEvent;
/**
 * 监听 `addEventListener` 点击事件
 * @param client 当前主实例
 * @param eventName 事件名称，例如 `click`
 * @returns 封装后的事件处理函数
 */
export function breadcrumbEventHandler(client, eventName) {
    return function (event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (lastCapturedEvent === event) {
            return;
        }
        lastCapturedEvent = event;
        // try/catch both:
        // - accessing event.target (see getsentry/raven-js#838, #768)
        // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
        //   can throw an exception in some circumstances.
        var target;
        try {
            target = htmlTreeAsString(event.target);
        }
        catch (e) {
            target = '<unknown>';
        }
        // target 路径存在为空的情况，需要过滤掉
        if (target) {
            var behavior = {
                category: "ui." + eventName,
                message: target,
                name: eventName // 事件名称，例如 'click'
            };
            // 如果是输入，记录输入的值
            if (eventName === 'input') {
                // 如果是密码，为了安全性，不进行记录
                if (target.type !== 'password') {
                    behavior.data = event.target.value || '';
                }
            }
            // 记录行为
            client.captureBehavior(behavior);
        }
    };
}
/**
 * 监听 `addEventListener` 键盘事件
 * @param client 当前主实例
 * @returns 封装后的事件处理函数
 */
export function keypressEventHandler(client) {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function (event) {
        var target;
        try {
            target = event.target;
        }
        catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName ||
            (tagName !== 'INPUT' &&
                tagName !== 'TEXTAREA' &&
                !target.isContentEditable)) {
            return;
        }
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!keypressTimeout) {
            breadcrumbEventHandler(client, 'input')(event);
        }
        clearTimeout(keypressTimeout);
        keypressTimeout = setTimeout(function () {
            keypressTimeout = undefined;
        }, debounceDuration);
    };
}
//# sourceMappingURL=helper.js.map